import { Lookup } from "@data-types";
import { RegionDataType } from "@data-types/membership/registration";
import { httpClient, retryRequest } from "@utils";
import { getApiRequestContext } from "@utils/api-config";
import { getApplicationRequestHeaders } from "@utils/api-config/getApplicationRequestHeader";
import { ApiRequestContextData } from "@utils/api-config/types";

class PlatformCountryRegionsApiService {
	static get baseUrl() {
		return `${WEBPACK_BASE_ADDRESS}platform/country-regions`;
	}

	static getRequestHeaders = (
		options: ApiRequestContextData = getApiRequestContext()
	) => {
		const appHeaders = getApplicationRequestHeaders(options);
		appHeaders["Content-Type" as keyof HeadersInit] = "application/json";
		return appHeaders;
	};

	static async findCountryRegions(
		countryId?: string | undefined
	): Promise<Lookup<RegionDataType>> {
		const params = new URLSearchParams({
			sort: "name|asc",
			rpp: "1000",
			translate: "true",
		});
		if (countryId) {
			params.set("countryIds", countryId);
		}
		const response = await retryRequest(() =>
			httpClient.get(
				`${this.baseUrl}?${params.toString()}`,
				this.getRequestHeaders()
			)
		);
		return response;
	}
}

export default PlatformCountryRegionsApiService;
